<template>
  <img :src="avatarUrl" @error="forceUsePlaceholderAvatar" alt="foto de perfil" :width="size" :height="size" />
</template>

<script>
import { PLACEHOLDER_AVATAR_PATH } from '@/constants/global'
import { createNamespacedHelpers } from 'vuex'

const { mapState: authStateMap } = createNamespacedHelpers('auth')

export default {
  props: {
    size: {
      type: Number,
      default: 82,
    },
  },
  data() {
    return {
      usePlaceholderAvatar: false,
    }
  },
  computed: {
    ...authStateMap(['userAvatarUrl']),
    noImg() {
      return PLACEHOLDER_AVATAR_PATH
    },
    avatarUrl() {
      if (this.usePlaceholderAvatar || !this.userAvatarUrl) {
        return PLACEHOLDER_AVATAR_PATH
      }

      return this.userAvatarUrl
    },
  },
  methods: {
    forceUsePlaceholderAvatar() {
      this.usePlaceholderAvatar = true
    },
  },
}
</script>

<style scoped>
img {
  border-radius: 50%;
}
</style>
